import { queryKeys } from '@/api/query-keys'
import { portraitsService } from '@/api/services/portraits.service'
import { type PortraitListQueryOptions, usePortraitListQuery } from './use-portrait-list-query'

/** The job's homerooms for the Homeroom dropdown, in the order the API returns them. */
export function usePortraitHomeroomsQuery({ enabled }: PortraitListQueryOptions = {}) {
  return usePortraitListQuery({
    queryKey: queryKeys.portraits.homerooms(),
    queryFn: () => portraitsService.getHomerooms(),
    enabled,
  })
}
